import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/client`; // Adjust this as necessary

export const createClient = (clientData) => axios.post(`${API_BASE_URL}/createclient`, clientData);

export const getClientById = (id) => axios.get(`${API_BASE_URL}/getclient/${id}`);

export const getClientByCodeClt = (codeClt) => axios.get(`${API_BASE_URL}/getclientbycodeclt/${codeClt}`);

export const updateClient = (id, clientData) => axios.put(`${API_BASE_URL}/updateclients/${id}`, clientData);

export const deleteClient = (id) => axios.delete(`${API_BASE_URL}/deleteclient/${id}`);

export const getAllClients = async (params = {}) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/getallclients`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const bulkUploadClients = (formData) => axios.post(`${API_BASE_URL}/bulk-upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  export const ClientStatement = (id, startDate, endDate) => 
    axios.get(`${API_BASE_URL}/statement/${id}`, {
      params: {
        startDate,
        endDate
      }
    });
